import CardStatusTrackerMFE from '@card-actions/card-status-tracker'
import getMFEConfig from 'helpers/getMFEConfig'
import { useAtom, useAtomValue } from 'jotai'
import { modalStatusAtom, selectedAccountAtom } from 'store/atoms'
import triggerAnalyticsEvent from 'helpers/triggerAnalyticsEvent'
import { useIVASetChatStatus } from 'iva-react-web-ui'

const CardStatusTrackerModal = () => {
  const selectedAccount = useAtomValue(selectedAccountAtom)
  const [{ modalId, modalTriggerId }, updateModalStatus] =
    useAtom(modalStatusAtom)
  const isModalOpen = modalId === 'CardStatusTracker'

  const handleCloseModal = () => {
    document.getElementById('card-status-tracker-link')?.focus()
    updateModalStatus('', '')
  }

  const { pointOfNeedChat } = useIVASetChatStatus()

  const handleLostOrStolenClick = () => {
    pointOfNeedChat('RLS', selectedAccount)
  }

  return (
    isModalOpen && (
      <CardStatusTrackerMFE
        closeModal={handleCloseModal}
        containerId={modalTriggerId}
        isModalOpen={isModalOpen}
        lostOrStolenMfeHandler={handleLostOrStolenClick}
        mfeConfig={getMFEConfig('mfe')}
        selectedAccountId={selectedAccount}
        triggerAnalyticsEvent={triggerAnalyticsEvent}
      />
    )
  )
}

export default CardStatusTrackerModal
